import { WorkOrderListTable } from "./WorkOrderListTable";

export default WorkOrderListTable;
